// AUTH
export const UPDATE_AUTH = "UPDATE_AUTH";
export const updateAuth = (auth) => ({
    type: UPDATE_AUTH,
    payload: auth,
});

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export const updatePermissions = (permissions) => ({
    type: UPDATE_PERMISSIONS,
    payload: permissions,
});

export const UPDATE_REQUIREMENTS = "UPDATE_REQUIREMENTS";
export const updateRequirements = (requirements) => ({
    type: UPDATE_REQUIREMENTS,
    payload: requirements,
});

export const UPDATE_OPTIONS = "UPDATE_OPTIONS";
export const updateOptions = (options) => ({
    type: UPDATE_OPTIONS,
    payload: options,
});

export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const updateLanguage = (language) => ({
    type: UPDATE_LANGUAGE,
    payload: language,
});

export const LOG_OUT = "LOG_OUT";
export const logOut = () => ({
    type: LOG_OUT,
});

// SETTINGS
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const updateSettings = (settings) => ({
    type: UPDATE_SETTINGS,
    settings,
});

export const UPDATE_SYSTEM_SETTINGS = "UPDATE_SYSTEM_SETTINGS";
export const updateSystemSettings = (systemSettings) => ({
    type: UPDATE_SYSTEM_SETTINGS,
    systemSettings,
});

// TOAST
export const ADD_TOAST = "ADD_TOAST";
export const addToast = (data) => ({
    type: ADD_TOAST,
    data,
});

export const REMOVE_TOAST = "REMOVE_TOAST";
export const removeToast = (id) => ({
    type: REMOVE_TOAST,
    id,
});

export const UPDATE_WINDOW_SIZE = "UPDATE_WINDOW_SIZE";
export const updateWindowSize = (id) => ({
    type: UPDATE_WINDOW_SIZE,
    id,
});

// STYLES
export const UPDATE_STYLES = "UPDATE_STYLES";
export const updateStyles = (styles) => ({
    type: UPDATE_STYLES,
    styles,
});

export const UPDATE_STATUS = "UPDATE_STATUS";
export const updateStatus = (status) => ({
    type: UPDATE_STATUS,
    status,
});

export const UPDATE_PAGE_LAYOUT = "UPDATE_PAGE_LAYOUT";
export const updatePageLayout = (pageLayout) => ({
    type: UPDATE_PAGE_LAYOUT,
    pageLayout,
});

//META APPS TYPES
export const UPDATE_META_APP_TYPES = "UPDATE_META_APP_TYPES";
export const updateMetaAppTypes = (metaAppTypes) => ({
    type: UPDATE_META_APP_TYPES,
    payload: metaAppTypes,
});

//SERVER CONNECTION STATE
export const UPDATE_SERVER_CONNECTION = "UPDATE_SERVER_CONNECTION";
export const updateServerConnection = (request) => ({
    type: UPDATE_SERVER_CONNECTION,
    payload: request,
});

// NAVBAR SHORTCUTS
export const UPDATE_DASHBOARD_STATE = "UPDATE_DASHBOARD_STATE";
export const updateDashboardState = (dashboard) => ({
    type: UPDATE_DASHBOARD_STATE,
    payload: dashboard,
});

export const DASHBOARD_EDITABLE = "DASHBOARD_EDITABLE";
export const dashboardEditable = (value: boolean) => ({
    type: DASHBOARD_EDITABLE,
    payload: value,
});

export const DASHBOARD_UNSAVED = "DASHBOARD_UNSAVED";
export const dashboardUnsaved = (value: boolean) => ({
    type: DASHBOARD_UNSAVED,
    payload: value,
});
